import { LocationConfigurationHolder } from "@tlc/ls2pac/components/LocationConfiguration";
import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";
import { CopiesControl } from "../controls/CopyControl";
import { DateControl } from "../controls/DateControl";
import { LocationSelectorControl } from "../controls/locationSelectorControl";
import { SimpleErrorDialog } from "../controls/simpleErrorDialog";
import { SuccessMessageControl } from "../controls/successMessageControl";
import { LS2PAC_Utils } from "../utils/Utils";

export const RequestsView = (function ($) {
  var batchTmpl = "tmpl/requests/batchRequestsForm.html"; //TODO make a separate class for batch vs. not batch...they can extend the same base class once we know what that common functionality is
  var tmpl = "tmpl/requests/requestsForm.html";
  var currentResource,
    locationSelector,
    batchLocationSelector,
    fromDateSelector,
    toDateSelector,
    delegatesInit = false;
let copiesControl;

  var resourceForBibliographicId = function (bibliographicId, isTitleLevel) {
    if (isTitleLevel === true) {
      return getResourceByHostBibliographicId(bibliographicId);
    } else {
      return getResourceByHoldingBarcode(bibliographicId);
    }
  };

  var getResourceByHostBibliographicId = function (hostBibliographicId) {
    var matchingResource = null;
    $.each(currentResource, function (index, resource) {
      if (resource.hostBibliographicId == hostBibliographicId) {
        matchingResource = resource;
        return;
      }
    });
    return matchingResource;
  };

  var getResourceByHoldingBarcode = function (barcode) {
    var matchingResource = null; //TODO do we really need to iterate, can we just return currentResource[0] if we are checking barcodes? If it's item level it is not batch
    if (currentResource[0].holdingsInformations != undefined) {
      $.each(currentResource[0].holdingsInformations, function (i, holding) {
        if (holding.barcode === barcode) {
          matchingResource = currentResource[0];
          return false;
        }
      });
    }
    return matchingResource;
  };

  var runBatchLocalConfigChecks = function () {
    var allowHolds = ApplicationData.locationConfiguration.getAllowHolds();
    if (allowHolds.restrictTitle === true) {
      batchLocationSelector.disable();
    } else {
      batchLocationSelector.enable();
    }
  };
  var runLocalConfigChecks = function (resource) {
    //TODO take inventory of what is used
    resource = resource || { availableLocally: false };
    var showBookings = ApplicationData.locationConfiguration.getAllowBookings(),
      allowHolds = ApplicationData.locationConfiguration.getAllowHolds();
    if (allowHolds.restrictTitle === true) {
      locationSelector.disable();
      locationSelector.hide();
    } else {
      locationSelector.enable();
      locationSelector.show();
    }
    var defaultEnabled = true;

    if (
      allowHolds.title === true &&
      showBookings === false &&
      allowHolds.item === false
    ) {
      $("#" + LS2PAC_CONSTANTS.Ids.Requests.requestOptionsDL).hide();
    } else {
      var numberOfRadiosShown = 0;
      if (
        !(
          allowHolds.title === false ||
          (!allowHolds.onShelf && resource.availableLocally) ||
          resource.serial === true
        )
      ) {
        $("#" + LS2PAC_CONSTANTS.Ids.Requests.requestTitleDD).show();
        numberOfRadiosShown++;
      } else {
        //need to check another option because this one is not visible
        defaultEnabled = false;
      }
      if (showBookings) {
        $("#" + LS2PAC_CONSTANTS.Ids.Requests.requestBookingsDD).show();
        numberOfRadiosShown++;
        if (!defaultEnabled) {
          defaultEnabled = true;
          $("#" + LS2PAC_CONSTANTS.Ids.Requests.bookingsOption).attr(
            "checked",
            "checked"
          );
          //This timeout (and the next) are to ensure the dialog has loaded before we try to toggle the form
          setTimeout(function () {
            toggleForm(LS2PAC_CONSTANTS.Ids.Requests.bookingsOption);
          }, 250);
        }
      }
      if (
        !(
          allowHolds.item === false ||
          (!allowHolds.onShelf && resource.availableLocally)
        )
      ) {
        $("#" + LS2PAC_CONSTANTS.Ids.Requests.requestItemDD).show();
        numberOfRadiosShown++;
        if (!defaultEnabled) {
          defaultEnabled = true;
          $("#" + LS2PAC_CONSTANTS.Ids.Requests.itemLevelOption).attr(
            "checked",
            "checked"
          );
          setTimeout(function () {
            toggleForm(LS2PAC_CONSTANTS.Ids.Requests.itemLevelOption);
          }, 350);
        }
      }
      if (numberOfRadiosShown < 2) {
        $("#" + LS2PAC_CONSTANTS.Ids.Requests.requestOptionsDL).hide();
      }
    }
  };
  var initControls = function () {
    locationSelector = new LocationSelectorControl({
      id: LS2PAC_CONSTANTS.Ids.Requests.locationSelector,
    });
    batchLocationSelector = new LocationSelectorControl({
      id: LS2PAC_CONSTANTS.Ids.Requests.batchLocationSelector,
    });
    fromDateSelector = new DateControl({
      id: LS2PAC_CONSTANTS.Ids.Requests.bookFrom,
    });
    toDateSelector = new DateControl({
      id: LS2PAC_CONSTANTS.Ids.Requests.bookTo,
    });
    copiesControl = new CopiesControl({
      id: LS2PAC_CONSTANTS.Ids.Requests.requestCopies,
      action: ApplicationData.language.request,
    });
  };

  var isBatchRequest = function (resources) {
    if (resources instanceof Array) {
      currentResource = resources;
      if (resources.length === 0) {
        throw "EmptyResourcesException"; //this should not happen
      } else if (resources.length === 1) {
        return false;
      } else {
        return true;
      }
    } else {
      currentResource = [resources];
      return false;
    }
  };

  var getMessageToken = function (messageTokenString) {
    return messageTokenString.replace(/</g, "").replace(/>/g, ""); //trim <>
  };

  var getMessageByMessageTokenString = function (messageTokenString) {
    var message = ApplicationData.language[getMessageToken(messageTokenString)];
    return message === undefined ? messageTokenString : message;
  };

  var isSingleResponse = function (placeHoldInfos) {
    if (placeHoldInfos !== undefined && placeHoldInfos !== null) {
      if (placeHoldInfos.length === 1) {
        return true;
      } else if (placeHoldInfos.length > 1) {
        return false;
      } else {
        throw "PlaceHoldInfosEmptyException";
      }
    } else {
      throw "PlaceHoldInfosNotFoundException";
    }
  };

  var getHoldSuccessAndFailures = function (placeHoldInfos) {
    var failedHolds = [],
      successfulHolds = $.grep(placeHoldInfos, function (placeHoldInfo) {
        if (placeHoldInfo.success === true) {
          return true;
        } else {
          failedHolds.push(placeHoldInfo);
          return false;
        }
      });
    return {
      success: successfulHolds,
      failure: failedHolds,
    };
  };

  const getFormattedGuardians = (guardians) => {
    const guardianNames = guardians.sort();
    switch (guardianNames.length) {
      case 1:
        return guardianNames[0];
      case 2:
        return guardianNames.join(" and ");
      default:
        return `${guardianNames.slice(0, -1).join(", ")}, and ${guardianNames[guardianNames.length - 1]}`;
    }
  };

  const getPlaceHoldInfoFailureMessage = (placeHoldInfo) => {
    let message = getMessageByMessageTokenString(placeHoldInfo.message);
    if (placeHoldInfo.guardiansBlocking?.length > 0) {
      message = `${message}: ${getFormattedGuardians(
        placeHoldInfo.guardiansBlocking
      )}`;
    }
    return message;
  };

  var groupFailedMessages = function (failedHolds) {
    var groups = [],
      keys = [];
    $.each(failedHolds, function (i, failed) {
      const message = getPlaceHoldInfoFailureMessage(failed);
      if (groups[message] === undefined) {
        groups[message] = {
          message: message,
          items: [failed],
        };
        keys.push(message);
      } else {
        groups[message].items.push(failed);
      }
    });
    return {
      groups: groups,
      keys: keys,
    };
  };

  var setupClickEvents = function () {

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRequest,
      function (event) {
        if (event.resource) {
          LoginClientManager.promptIfNotLoggedIn(
            function (user) {
              if (LS2PAC_Utils.isValidPatronIdUser(user)) {
                if (
                  LS2PAC_Utils.showRequestButton(event.resource) &&
                  !event.resource.disableRequestButton
                ) {
                  if (isBatchRequest(event.resource)) {
                    showBatchRequestsDialog(
                      event.resource,
                      event.closeCallback
                    );
                  } else {
                    if (Array.isArray(event.resource)) {
                      if (event.resource.length > 0) {
                        showRequestDialog(
                          event.resource[0],
                          event.closeCallback
                        );
                      }
                    } else {
                      showRequestDialog(event.resource, event.closeCallback);
                    }
                  }
                } else {
                  // This dialog shouldn't have displayed and we already compensated for an invalid user type
                  SimpleErrorDialog.show(ApplicationData.language.OnShelfError);
                }
              } else {
                SimpleErrorDialog.show(
                  ApplicationData.language.noPatronIdError
                );
              }
            },
            function () {
              if (event.closeCallback) {
                event.closeCallback();
              }
            }
          );
        } else {
          //TODO throw an exception?
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onPlaceBookingReturn,
      function (event) {
        if (event.success === false) {
          var message = getMessageByMessageTokenString(event.data.reason);
          //TODO diplay first available date
          showRequestFeedbackDialog(message);
        } else {
          SuccessMessageControl.show(
            ApplicationData.language.successfulBookingMessage
          );
        }
      }
    );

    var getHoldingByBarcode = function (resource, barcode) {
      for (var x = 0; x < resource.holdingsInformations.length; x++) {
        if (resource.holdingsInformations[x].barcode === barcode) {
          return resource.holdingsInformations[x];
        }
      }
      return null;
    };

    var getItemDescription = function (resource, barcode) {
      var holding = getHoldingByBarcode(resource, barcode);
      if (resource.serial) {
        return (
          holding.chronology +
          "; " +
          holding.enumeration +
          "; " +
          holding.branchName +
          "; " +
          holding.collectionName
        );
      }

      return (
        holding.shelfLocation +
        "; " +
        holding.branchName +
        "; " +
        holding.collectionName
      );
    };

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRequestResponse,
      function (event) {
        var placeHoldInfos = event.data.placeHoldInfos;
        if (isSingleResponse(placeHoldInfos)) {
          var message = getMessageByMessageTokenString(
            event.data.placeHoldInfos[0].message
          );
          if (placeHoldInfos[0].success === true) {
            SuccessMessageControl.show(message);
          } else {
            const message = getPlaceHoldInfoFailureMessage(
              event.data.placeHoldInfos[0]
            );
            showRequestFeedbackDialog(message);
          }
        } else {
          var holds = getHoldSuccessAndFailures(placeHoldInfos);
          if (holds.failure.length === 0 && holds.success.length > 0) {
            SuccessMessageControl.show(
              ApplicationData.language.batchRequestSuccessMessage
            );
          } else {
            const failedMessages = groupFailedMessages(holds.failure);
            var content = [],
              i = 0;
            content[i++] = "<div class='RequestsResponse'>";
            if (holds.success.length > 0) {
              content[i++] =
                "<h2>" +
                ApplicationData.language.batchRequestSuccessMessage +
                "</h2>";
              content[i++] = "<ul>";

              $.each(holds.success, function (j, successfulHold) {
                var resource = resourceForBibliographicId(
                  successfulHold.bibliographicId,
                  successfulHold.titleLevelHold
                );
                if (successfulHold.titleLevelHold) {
                  content[i++] =
                    '<li data-bibliographic-id="' +
                    resource.hostBibliographicId +
                    '">' +
                    resource.shortTitle +
                    "</li>";
                } else {
                  content[i++] =
                    '<li data-barcode="' +
                    successfulHold.bibliographicId +
                    '">' +
                    getItemDescription(
                      resource,
                      successfulHold.bibliographicId
                    ) +
                    "</li>";
                }
              });

              content[i++] = "</ul>";
            }
            if (failedMessages.keys.length > 0) {
              //TODO do we need to actually check this?
              content[i++] =
                "<h2>" +
                ApplicationData.language.batchRequestFailureMessage +
                "</h2>";
              content[i++] = "<dl>";
              $.each(failedMessages.keys, function (k, failedMessageKey) {
                content[i++] =
                  "<dt>" +
                  failedMessages.groups[failedMessageKey].message +
                  "</dt>";
                $.each(
                  failedMessages.groups[failedMessageKey].items,
                  function (l, item) {
                    var resource = item;
                    if (resource.shortTitle === undefined) {
                      resource = resourceForBibliographicId(
                        item.bibliographicId,
                        item.titleLevelHold
                      );
                    }

                    if (item.titleLevelHold) {
                      content[i++] =
                        '<dd data-bibliographic-id="' +
                        resource.hostBibliographicId +
                        '">' +
                        resource.shortTitle +
                        "</dd>";
                    } else {
                      content[i++] =
                        '<dd data-barcode="' +
                        item.bibliographicId +
                        '">' +
                        getItemDescription(resource, item.bibliographicId) +
                        "</dd>";
                    }
                  }
                );
              });

              content[i++] = "</dl>";
            }
            content[i++] = "</div>";
            showRequestFeedbackDialog(content.join(""));
          }
        }
      }
    );

    LocationConfigurationHolder.subscribe( () => {
      runLocalConfigChecks();
      runBatchLocalConfigChecks(); //TODO necessary anymore?
    })

  };
  var toggleSubmit = function () {
    if (isSubmitActive() === true) {
      $("#dialogContainer")
        .find("input[type='submit']")
        .prop("disabled", false)
        .removeClass("disabled");
    } else {
      $("#dialogContainer")
        .find("input[type='submit']")
        .attr("disabled", "disabled")
        .addClass("disabled");
    }
  };

  var toggleForm = function (requestType) {
    switch (requestType) {
      case LS2PAC_CONSTANTS.Ids.Requests.bookingsOption:
        toggleSubmit();
        toDateSelector.enable();
        fromDateSelector.enable();
        copiesControl.disable();
        break;
      case LS2PAC_CONSTANTS.Ids.Requests.titleLevelOption:
        toggleSubmit();
        toDateSelector.disable();
        fromDateSelector.disable();
        copiesControl.disable();
        break;
      case LS2PAC_CONSTANTS.Ids.Requests.itemLevelOption:
        toggleSubmit();
        toDateSelector.disable();
        fromDateSelector.disable();
        copiesControl.enable();
        break;
    }
  };

  var setupDelegates = function () {
    if (delegatesInit !== true) {
      //it would be bad form to use the dialog id as we dump and re-render each time... could use the outer dialog
      //$("#" + LS2PAC_CONSTANTS.Ids.dialogContainer)
      //DialogContainer fires undelegate ever time it closes so we can't attach to that. everything below that gets dumped and re-rendered so our only option here is body
      $("body").on(
        "change",
        "#" +
          LS2PAC_CONSTANTS.Ids.Requests.requestsForm +
          " input:radio[name=requestType]",
        function (event) {
          //dialog may not be shown at this time
          toggleForm(event.currentTarget.id);
        }
      );
      copiesControl.onChange(function () {
        toggleSubmit();
      });
      toDateSelector.onChange(function () {
        toggleSubmit();
      });
      fromDateSelector.onChange(function () {
        toggleSubmit();
      });
      delegatesInit = true;
    }
  };

  var hasPrompt = function () {
    var showBookings = ApplicationData.locationConfiguration.getAllowBookings(),
      allowHolds = ApplicationData.locationConfiguration.getAllowHolds();
    if (
      allowHolds.restrictTitle === true &&
      showBookings === false &&
      allowHolds.item === false
    ) {
      return false;
    } else {
      return true;
    }
  };

  var getPickupBranchId = function (pickupBranchId) {
    if (pickupBranchId === undefined || pickupBranchId === null) {
      pickupBranchId = ApplicationData.getUserDefaultPickupBranch();
    }
    return pickupBranchId;
  };

  var placeTitleLevelHold = function (pickupBranch, callback) {
    var pickupBranchId = getPickupBranchId(pickupBranch);
    fireRequest(currentResource, pickupBranchId, true, callback);
  };

  var isSubmitActive = function () {
    var requestType = getRequestType();
    switch (requestType) {
      case LS2PAC_CONSTANTS.Ids.Requests.bookingsOption:
        if (
          fromDateSelector.getCurrentSelection() > "" &&
          toDateSelector.getCurrentSelection() > ""
        ) {
          return true;
          //TODO typing 02 and 02 in each field works...though not a valid date
          //maybe we need extended validation, back end should also check... same with first before second and not same
        } else {
          return false;
        }
      case LS2PAC_CONSTANTS.Ids.Requests.titleLevelOption:
        return true;
      case LS2PAC_CONSTANTS.Ids.Requests.itemLevelOption:
        var selectedCopies = copiesControl.getCurrentSelection();
        if (selectedCopies.length > 0) {
          return true;
        } else {
          return false;
        }
    }
  };

  var fireRequest = function (
    resources,
    pickupBranchId,
    isTitleLevel,
    callback
  ) {
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSubmitRequest, {
      data: resources,
      pickupBranchId: pickupBranchId,
      isTitleLevel: isTitleLevel,
    });
    if (callback) {
      callback();
    }
  };

  var showRequestDialog = function (resource, closeCallback) {
    if (hasPrompt()) {
      locationSelector.render(function (locationSelectorOptions) {
        TemplateEngine.compile(
          tmpl,
          {
            locationSelectorOptions: locationSelectorOptions,
            resource: resource,
          },
          function (content) {
            DialogManager.show({
              content: content,
              dialogTitle:
                ApplicationData.language.placeARequestPrefix +
                " " +
                ApplicationData.language.request,
              okText:
                ApplicationData.language.submit +
                " " +
                ApplicationData.language.request,
              submitCallback: function (event) {
                handleApplyCallback(event);
              },
              callback: function () {
                copiesControl.render(resource); //TODO we can postpone this...
                locationSelector.setDefaultSelection();
                fromDateSelector.render({ constrainInput: true });
                toDateSelector.render({ constrainInput: true });
                fromDateSelector.setCurrentDate();
                toDateSelector.setFutureDate(1);
                fromDateSelector.disable();
                toDateSelector.disable();
                setupDelegates();
                runLocalConfigChecks(resource);
              },
              closeCallback: closeCallback,
            });
          }
        );
      });
    } else {
      placeTitleLevelHold(null, closeCallback);
    }
  };

  var showBatchRequestsDialog = function (resource, closeCallback) {
    var allowHolds = ApplicationData.locationConfiguration.getAllowHolds();
    if (allowHolds.restrictTitle === true) {
      placeTitleLevelHold(null, closeCallback);
    } else {
      batchLocationSelector.render(function (locationSelectorOptions) {
        TemplateEngine.compile(
          batchTmpl,
          {
            locationSelectorOptions: locationSelectorOptions,
          },
          function (content) {
            DialogManager.show({
              content: content,
              dialogTitle:
                ApplicationData.language.placeARequestPrefix +
                " " +
                ApplicationData.language.request,
              okText:
                ApplicationData.language.submit +
                " " +
                ApplicationData.language.request,
              submitCallback: function (event) {
                handleApplyCallback(event);
              },
              callback: function () {
                batchLocationSelector.setDefaultSelection();
                runBatchLocalConfigChecks();
              },
              closeCallback: closeCallback,
            });
          }
        );
      });
    }
  };
  var showRequestFeedbackDialog = function (content) {
    DialogManager.show({
      content: content,
      dialogTitle: ApplicationData.language.errorDialogTitle,
    });
  };

  /*var getPlaceHoldInfo = function(bibliographicIdOrBarcode, pickupBranchId, isTitleLevelHold){
	 //TODO consider isTitleLevelHold?resource.hostBibliographicId:resource.barcode as an improvement and pass the resource.
	 return {
	 bibliographicId: bibliographicIdOrBarcode,
	 pickupBranchId: pickupBranchId,
	 titleLevelHold: isTitleLevelHold.toString(),
	 interfaceType: "PAC"
	 };
	 };*/

  var placeItemLevelHold = function (copies, pickupBranch, callback) {
    var pickupBranchId = getPickupBranchId(pickupBranch);
    if (copies.length === 0) {
      throw "RequestCopiesEmptyException"; //This should not occur in runtime because of the validation
    } else {
      fireRequest(copies, pickupBranchId, false, callback); //TODO, can resourceType !== 1 get here? if individual, we should block. Batch is title level - same with downloadable
    }
  };

  var getRequestType = function () {
    return $(
      "#" +
        LS2PAC_CONSTANTS.Ids.Requests.requestsForm +
        " input:radio[name=requestType]:checked"
    ).attr("id");
  };
  var handleApplyCallback = function (event) {
    var requestType = getRequestType();
    switch (requestType) {
      case LS2PAC_CONSTANTS.Ids.Requests.bookingsOption:
        var placeBookingParameters = {
          branchId: locationSelector.getCurrentSelection(),
          recordId: currentResource[0].hostBibliographicId,
          startDate: fromDateSelector.getCurrentSelection(),
          endDate: toDateSelector.getCurrentSelection(),
          bookFirstAvailable: false,
        };
        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onPlaceBookings, {
          placeBookingParameters: placeBookingParameters,
        });
        break;
      case LS2PAC_CONSTANTS.Ids.Requests.titleLevelOption:
        placeTitleLevelHold(locationSelector.getCurrentSelection());
        break;
      case LS2PAC_CONSTANTS.Ids.Requests.itemLevelOption:
        placeItemLevelHold(
          copiesControl.getCurrentSelection(),
          locationSelector.getCurrentSelection()
        );
        break;
      default:
        placeTitleLevelHold(batchLocationSelector.getCurrentSelection());
        break;
    }
  };

  return {
    init: function () {
      initControls();
      setupClickEvents();
    },
  };
})(jQuery);
